import type { FetchHttpError } from '@bonusly/http-client';

export type HttpError = FetchHttpError;

export const isHttpErrorType = (error: unknown): error is HttpError => {
	return typeof error === 'object' && error !== null && 'response' in error;
};

export type PossibleHttpError = HttpError | Error;
